import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation UpdateChannelsGroup($id: ID!, $model: ChannelGroupInput!) {
  updateGroupChannel(id: $id, group: $model) {
    id
    name
    description
    config
  }
}`;

function updateChannelsGroup(id, config, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model: {
        ...model,
        config: JSON.stringify(config),
      },
    },
  }).then((res) => res.data.updateGroupChannel);
}

export default updateChannelsGroup;
